<script>
    import moment from 'moment'

    export default {
        name: 'UnavailabilityItem',
        data() {
            return {
                height: 0,
                zIndex: 1,
                top: 0,
            }
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            agendaStart: {
                type: Number,
                default: 0,
            },
            agendaDuration: {
                type: Number,
                default: 24,
            },
        },
        watch: {
            'item.date': function(newVal, oldVal) {
                if(moment(oldVal).format('YYYY-MM-DD') != newVal) {
                    this.$emit('change-date', this, oldVal, newVal)
                }
            },
            'item.time': function(newVal) {
                const timeArray = newVal.split(':');
                const minutes = ((+timeArray[0]) * 60 + (+timeArray[1]));

                if(this.moving === false)
                {
                    this.zIndex = minutes + 1
                }
                let top = (minutes - this.agendaStart * 60) * 100 / (this.agendaDuration * 60)
                this.top = top + '%'
            },
            'item.duration': function(newVal) {
                if(this.item.duration < 5)
                {
                    this.item.duration = 5
                }

                this.height = parseFloat(this.item.duration * 100 / (this.agendaDuration * 60)).toFixed(2) + '%';
            },
            'item.moving': function() {
                if(this.item.moving === true) {
                    this.zIndex = 1500
                }
                else {
                    const timeArray = this.item.time.split(':')

                    this.zIndex = ((+timeArray[0]) * 60 + (+timeArray[1])) + 1
                }
            }
        },
        methods: {
            reasonName(id) {
                const reasons = this.$store.state.account.unavailabilityReasons
                const found = reasons.find(element => element.id == id)

                return found.name;
            },
        },
        created() {
            const reasons = this.$store.state.account.reasons;

            const timeArray = this.item.time.toString().split(':');
            const minutes = ((+timeArray[0]) * 60 + (+timeArray[1]));

            this.top = parseFloat((minutes - this.agendaStart * 60) * 100 / (this.agendaDuration * 60)).toFixed(2) + '%';
            this.zIndex = minutes + 1;
            this.height = parseFloat(this.item.duration * 100 / (this.agendaDuration * 60)).toFixed(2) + '%';
        },
        computed: {
            type() {
                if(this.item.weekly == 1) {
                    return 'crossed-weekly'
                }

                return 'crossed'
            },
            border() {
                if((parseInt(this.item.time.slice(3, 5)) + this.item.duration) % 60 != 0) {
                    return 'border-b'
                }

                return ''
            }
        },
    }
</script>

<template>
<div>
    <div
        class="rdz absolute bg-gray-400 m-0 p-0 flex w-full border-r border-t border-black select-none"
        :class="[type, border]"
    >
        <div class="w-full relative m-1 p-0 overflow-hidden">
                <div v-show="item.duration >= 18" class="m-0 p-1 w-full flex justify-center">
                    <span v-if="item.reason_id" class="m-0 px-2 py-1 text-xs font-bold bg-white border">{{ reasonName(item.reason_id) }}</span>
                </div>
        </div>
    </div>
</div>
</template>

<style scoped>

.rdz {
    top: v-bind('top');
    z-index: v-bind('zIndex');
    height: v-bind('height');
}

.crossed {
     background: 
     repeating-linear-gradient(
        45deg,
        #ffcece 0px,
        #ffcece 3px,
        #ffffff 3px,
        #ffffff 12px
    );
}

.crossed-weekly {
     background: 
     repeating-linear-gradient(
        45deg,
        #dadada 0px,
        #dadada 3px,
        #ffffff 3px,
        #ffffff 12px
    );
}

</style>